import BaseLogger from "./BaseLogger";

const LOG_DEBUG = typeof window !== "undefined";

export default class ConsoleLogger extends BaseLogger {
  override log(...data: any[]): void;
  override log(message?: any, ...optionalParams: any[]): void;
  override log(message?: unknown, ...optionalParams: unknown[]): void {
    console.log(message, ...optionalParams);
  }

  override debug(...data: any[]): void;
  override debug(message?: any, ...optionalParams: any[]): void;
  override debug(message?: unknown, ...optionalParams: unknown[]): void {
    if (LOG_DEBUG) {
      console.debug(message, ...optionalParams);
    }
  }

  override warn(...data: any[]): void;
  override warn(message?: any, ...optionalParams: any[]): void;
  override warn(message?: unknown, ...optionalParams: unknown[]): void {
    console.warn(message, ...optionalParams);
  }

  override error(...data: any[]): void;
  override error(message?: any, ...optionalParams: any[]): void;
  override error(message?: unknown, ...optionalParams: unknown[]): void {
    console.error(message, ...optionalParams);
  }

  override group(...data: any[]): void;
  override group(...label: any[]): void;
  override group(...label: unknown[]): void {
    console.group(...label);
  }

  override groupCollapsed(...data: any[]): void;
  override groupCollapsed(...label: any[]): void;
  override groupCollapsed(...label: unknown[]): void {
    console.groupCollapsed(...label);
  }

  override groupEnd(): void;
  override groupEnd(): void;
  override groupEnd(): void {
    console.groupEnd();
  }

  override table(tabularData?: any, properties?: string[]): void;
  override table(tabularData: any, properties?: readonly string[]): void;
  override table(tabularData?: unknown, properties?: unknown): void {
    console.table(tabularData, properties as any);
  }
}
